module.exports = __webpack_public_path__ + "img/01_sub_no.bda267ac.svg";